export default __webpack_public_path__ + "static/media/refer-title.7c5f3365.png";